import tokens from '../../../packages/brand/tokens.json'

/** Brand colours as CSS custom properties, straight from packages/brand/tokens.json (ADR-0011). */
export function applyBrandTokens(root: HTMLElement = document.documentElement): void {
  for (const [name, value] of Object.entries(tokens.color)) {
    if (typeof value === 'string') root.style.setProperty(`--${kebab(name)}`, value)
  }
}

function kebab(s: string): string {
  return s.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)
}
